module.exports = __webpack_public_path__ + "static/media/our_day.d6e830bd.svg";